import { render, staticRenderFns } from "./help-notice.vue?vue&type=template&id=191f2b9e"
import script from "./help-notice.vue?vue&type=script&lang=js"
export * from "./help-notice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports